<template>
	<div class="info">
		<div>
			<LinkIcon v-if="actionIcon === 'LinkIcon'" :size="20" />
			<EditIcon v-if="actionIcon === 'EditIcon'" :size="20" />
			<DuplicateIcon v-if="actionIcon === 'DuplicateIcon'" :size="20" />
			<DeleteIcon v-if="actionIcon === 'DeleteIcon'" :size="20" />
			<PdfIcon v-if="actionIcon === 'ReportIcon'" :size="20" />
			<FileUploadIcon v-if="actionIcon === 'FileUploadIcon'" :size="20" />
		</div>
		<transition name="tooltip">
			<div class="info-box">
				<div class="info-text">
					{{ informationText }}
				</div>
			</div>
		</transition>
	</div>
</template>

<script>
import InformationIcon from '@/components/shared/Icons/InformationIcon.vue';
import DuplicateIcon from '@/components/shared/Icons/DuplicateIcon.vue';
import EditIcon from '@/components/shared/Icons/EditIcon.vue';
import DeleteIcon from '@/components/shared/Icons/DeleteIcon.vue';
import LinkIcon from '@/components/shared/Icons/LinkIcon.vue';
import PdfIcon from '@/components/shared/Icons/PdfIcon.vue';
import FileUploadIcon from '@/components/shared/Icons/FileUploadIcon.vue';

export default {
	name: 'Tooltip',
	components: {
		InformationIcon,
		FileUploadIcon,
		DuplicateIcon,
		EditIcon,
		DeleteIcon,
		LinkIcon,
		PdfIcon,
	},
	props: {
		informationText: {
			required: true,
		},
		actionIcon: {
			default: '',
		},
	},
	data: () => ({}),
	mounted() {},
	methods: {},
	computed: {},
};
</script>

<style lang="scss" scoped>
@import 'Tooltip.scss';
</style>
